module.exports = __webpack_public_path__ + "img/41.9.TU.340682b3.png";